import "../css/product.css";
import "./catalogue.js";
import { sameOriginUrl } from "./dom.js";

const product = window.nanzoraStorefront?.product;
if (product?.id) {
  const items = JSON.parse(
    localStorage.getItem("nanzora_recently_viewed") ?? "[]",
  ).filter((item) => item.id !== product.id);
  items.unshift(product);
  localStorage.setItem(
    "nanzora_recently_viewed",
    JSON.stringify(items.slice(0, 8)),
  );
  window.nanzoraEmit?.("view_item", {
    productId: product.id,
    itemName: product.name,
  });
}

const items = JSON.parse(
  localStorage.getItem("nanzora_recently_viewed") ?? "[]",
)
  .filter((item) => item.id !== product?.id)
  .slice(0, 4);
const list = document.querySelector("[data-nanzora-recently-viewed]");
if (list && items.length) {
  list.replaceChildren(
    ...items.flatMap((item) => {
      const href = sameOriginUrl(item.url);
      if (!href) {
        return [];
      }

      const link = document.createElement("a");
      link.className = "nanzora-recent-card";
      link.href = href;

      const image = document.createElement("img");
      const imageHref = sameOriginUrl(item.image);
      if (imageHref) {
        image.src = imageHref;
      }
      image.alt = "";
      image.loading = "lazy";

      const name = document.createElement("strong");
      name.textContent = String(item.name ?? "");

      const price = document.createElement("span");
      price.textContent = String(item.price ?? "");

      link.append(image, name, price);
      return [link];
    }),
  );
} else {
  list?.closest(".nanzora-recently-viewed")?.remove();
}

const shareRoot = document.querySelector(".nanzora-share");
const shareUrl = product?.url;
if (shareRoot && shareUrl) {
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(String(product?.name ?? ""));
  const hrefs = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    x: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${encodedUrl}`,
    whatsapp: `https://wa.me/?text=${encodedUrl}`,
  };

  for (const [network, href] of Object.entries(hrefs)) {
    const link = shareRoot.querySelector(`[data-nanzora-share="${network}"]`);
    link?.setAttribute("href", href);
  }
}

document
  .querySelector("[data-nanzora-web-share]")
  ?.addEventListener("click", async () => {
    const share = window.nanzoraStorefront?.product;
    if (!share?.url) return;
    if (navigator.share) {
      await navigator.share({
        title: share.name,
        url: share.url,
      });
    }
  });
